import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import JsBarcode from 'jsbarcode';
import logoamerisa from '../assets/logoamerisa.png';

// Función para generar un PNG de código de barras en base64
function generateBarcodeBase64(text) {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, text, { format: 'CODE128', width: 2, height: 40, displayValue: false });
  return canvas.toDataURL('image/png');
}

const styles = StyleSheet.create({
  page: {
    padding: 32,
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },
  logo: {
    width: 80,
    height: 40,
  },
  barcode: {
    width: 160,
    height: 40,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 8,
    color: '#1a237e',
  },
  section: {
    marginBottom: 12,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '16%',
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderRightWidth: 1,
    backgroundColor: '#e3e6f3',
    fontWeight: 'bold',
    padding: 4,
    fontSize: 10,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tableCol: {
    width: '16%',
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderRightWidth: 1,
    padding: 4,
    fontSize: 10,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

const OrdenEntradaPDF = ({ orden }) => {
  const barcodeBase64 = generateBarcodeBase64(orden.iddocumento);
  // Generar códigos de barras base64 para cada producto (SKU)
  const productosConBarcode = orden.productos.map(p => ({
    ...p,
    barcode: generateBarcodeBase64(p.sku)
  }));
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image src={logoamerisa} style={styles.logo} />
          <Text style={styles.title}>Orden de Entrada</Text>
          <Image src={barcodeBase64} style={styles.barcode} />
        </View>
        <View style={styles.section}>
          <Text>ID Documento: {orden.iddocumento}</Text>
          <Text>Fecha: {orden.fecha}</Text>
          <Text>Cliente: {orden.cliente_nombre || orden.cliente}</Text>
          <Text>Almacén: {orden.almacen_nombre || orden.almacen}</Text>
          <Text>Referencia: {orden.referencia || '-'}</Text>
          <Text>Observaciones: {orden.observaciones || '-'}</Text>
        </View>
        <View style={styles.section}>
          <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>Productos</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableColHeader}>SKU</Text>
              <Text style={styles.tableColHeader}>SKU Cliente</Text>
              <Text style={styles.tableColHeader}>Descripción</Text>
              <Text style={styles.tableColHeader}>UM</Text>
              <Text style={styles.tableColHeader}>Cantidad</Text>
              <Text style={styles.tableColHeader}>Lote</Text>
              <Text style={styles.tableColHeader}>Caducidad</Text>
              <Text style={styles.tableColHeader}>Serie</Text>
            </View>
            {orden.productos.map((p, idx) => (
              <View style={styles.tableRow} key={idx}>
                <Text style={styles.tableCol}>{p.sku}</Text>
                <Text style={styles.tableCol}>{p.sku_cliente || ''}</Text>
                <Text style={styles.tableCol}>{p.descripcion}</Text>
                <Text style={styles.tableCol}>{p.unidad}</Text>
                <Text style={styles.tableCol}>{p.cantidad}</Text>
                <Text style={styles.tableCol}>{p.lote}</Text>
                <Text style={styles.tableCol}>{p.caducidad || '-'}</Text>
                <Text style={styles.tableCol}>{p.serie}</Text>
              </View>
            ))}
          </View>
        </View>
      </Page>
      {/* Segunda hoja: listado de productos con código de barras */}
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>Listado de productos - Códigos escaneables</Text>
        <View style={{ marginTop: 16 }}>
          {productosConBarcode.map((p, idx) => (
            <View key={idx} style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 24 }}>
              <Image src={p.barcode} style={{ width: 160, height: 40, marginRight: 16 }} />
              <View>
                <Text style={{ fontWeight: 'bold' }}>{p.sku}</Text>
                <Text>{p.descripcion}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default OrdenEntradaPDF;
